<template>
  <div v-if="showMenu">
    <div class="button" @click="open(0, 0)">Mosaic Baby</div>
    <div class="button" @click="open(0, 1)">Mosaic Easy</div>
    <div class="button" @click="open(0, 2)">Mosaic Medium 1</div>
    <div class="button" @click="open(0, 3)">Mosaic Medium 2</div>
    <div class="button" @click="open(0, 4)">Mosaic Hard</div>
    <div class="button" @click="open(0, 5)">Mosaic Extreme</div>
    <div class="button" @click="open(1)">Planes</div>
    <!-- <div class="button" @click="open(2)">Puzzle 3x3</div>
    <div class="button" @click="open(3)">Puzzle 4x4</div> -->
    <div class="button" @click="open(4)">Letter</div>
    <div class="button" @click="open(5)">Color</div>
  </div>

  <div v-if="currentOpen === 1" class="popUp">
    <div class="button" @click="close">CLOSE</div>
    <Planes />
  </div>
  <div v-else-if="currentOpen === 0" class="popUp">
    <div class="button" @click="close">CLOSE</div>
    <Mosaic :setup="mosaic[extendedSelector]" />
  </div>
  <!-- <div v-else-if="currentOpen === 2" class="popUp">
    <div class="button" @click="close">CLOSE</div>
    <Puzzle :puzzleServer="puzzles.hard[0]" />
  </div>
  <div v-else-if="currentOpen === 3" class="popUp">
    <div class="button" @click="close">CLOSE</div>
    <Puzzle :puzzleServer="puzzles.hard[1]" />
  </div> -->
  <div v-else-if="currentOpen === 4" class="popUp">
    <div class="button" @click="close">CLOSE</div>
    <Letter />
  </div>
  <div v-else-if="currentOpen === 5" class="popUp">
    <div class="button" @click="close">CLOSE</div>
    <Color />
  </div>
</template>

<script>
import Planes from "./Planes.vue";
import Mosaic from "./Mosaic.vue";
// import Puzzle from "./Puzzle.vue";
import Letter from "./Letter.vue";
import Color from "./Color.vue";

export default {
  name: "Main",
  components: {
    Planes,
    Mosaic,
    // Puzzle,
    Letter,
    Color,
  },
  data() {
    return {
      showMenu: true,
      currentOpen: -1,
      extendedSelector: -1,
      puzzles: {
        easy: [
          [3, 0, 2, 6, 5, 7, 1, 4, 0],
          [3, 13, 0, 2, 6, 10, 12, 5, 7, 14, 1, 4, 0, 8, 9, 11],
          [
            3, 13, 0, 2, 6, 10, 12, 5, 7, 14, 1, 4, 0, 8, 9, 11, 15, 16, 17, 18,
            19, 20, 21, 22, 0,
          ],
        ],
        hard: [
          [3, 8, 2, 6, 5, 1, 7, 4, 0],
          [3, 13, 0, 2, 6, 10, 15, 5, 7, 14, 1, 4, 12, 8, 9, 11],
          [
            3, 13, 0, 2, 6, 10, 12, 5, 7, 14, 1, 4, 23, 8, 9, 11, 15, 16, 17,
            18, 19, 20, 21, 22, 0,
          ],
        ],
      },
      mosaic: [
        {
          x: 3,
          y: 3,
          preSelectionAmount: 3,
          preSelectionAmountMax: 3,
          stage: 0,
          maxlevel: 0,
          showTime: 2000,
          showTimeStep: 150,
          showTimeMin: 500,
          hideTime: 1500,
          hideTimeStep: 100,
          hideTimeMin: 700,
          goal: 100,
          code: "1A",
          toleranz: 3,
        },
        {
          x: 4,
          y: 4,
          preSelectionAmount: 3,
          preSelectionAmountMax: 4,
          stage: 0,
          maxlevel: 0,
          showTime: 1700,
          showTimeStep: 150,
          showTimeMin: 500,
          hideTime: 1300,
          hideTimeStep: 100,
          hideTimeMin: 700,
          goal: 100,
          code: "2B",
          toleranz: 2,
        },
        {
          x: 5,
          y: 4,
          preSelectionAmount: 4,
          preSelectionAmountMax: 6,
          stage: 0,
          maxlevel: 0,
          showTime: 1500,
          showTimeStep: 150,
          showTimeMin: 500,
          hideTime: 1300,
          hideTimeStep: 100,
          hideTimeMin: 700,
          goal: 200,
          code: "3C",
          toleranz: 2,
        },
        {
          x: 4,
          y: 5,
          preSelectionAmount: 4,
          preSelectionAmountMax: 6,
          stage: 0,
          maxlevel: 2,
          showTime: 1600,
          showTimeStep: 150,
          showTimeMin: 500,
          hideTime: 1200,
          hideTimeStep: 100,
          hideTimeMin: 700,
          goal: 300,
          code: "3C",
          toleranz: 2,
        },
        {
          x: 5,
          y: 5,
          preSelectionAmount: 4,
          preSelectionAmountMax: 8,
          stage: 0,
          maxlevel: 2,
          showTime: 1200,
          showTimeStep: 150,
          showTimeMin: 500,
          hideTime: 1100,
          hideTimeStep: 100,
          hideTimeMin: 700,
          goal: 350,
          code: "4D",
          toleranz: 2,
        },
        {
          x: 6,
          y: 6,
          preSelectionAmount: 4,
          preSelectionAmountMax: 9,
          stage: 0,
          maxlevel: 1,
          showTime: 1000,
          showTimeStep: 150,
          showTimeMin: 500,
          hideTime: 1000,
          hideTimeStep: 100,
          hideTimeMin: 500,
          goal: 450,
          code: "5E",
          toleranz: 2,
        },
      ],
    };
  },
  methods: {
    open(i, extended) {
      this.showMenu = false;
      this.currentOpen = i;
      if (extended >= 0) {
        this.extendedSelector = extended;
      } else {
        this.extendedSelector = -1;
      }
    },
    close() {
      this.showMenu = true;
      this.currentOpen = -1;
      this.extendedSelector = -1;
    },
  },
};
</script>

<style>
.button {
  margin: 10px auto;
  border: 2px solid black;
  width: 130px;
  border-radius: 10px;
  cursor: pointer;
  padding: 10px;
}

.button:hover {
  background: black;
  color: white;
}

.popUp {
  position: absolute;
  left: 50%;
  top: 0;
  transform: translateX(-50%);
  width: 70%;
  height: 100%;
  background: rgb(255 255 255 / 80%);
  border: 2px solid;
  border-radius: 10px;
  padding-bottom: 50px;
}
</style>
